import { WeighInListsDownloads } from './weighInLists';
import { StartListsDownloads } from './startLists';
import { AthletesCardsDownloads } from './athletesCards';
import { EntryListsDownloads } from './entryLists';
import { ProtocolsDownloads } from './protocols';
import { Header, Table } from '../../components';
import {
  liftsSelector,
  eventsSelector,
  entriesSelector,
  sessionsSelector,
  protocolsSelector,
} from '../../orm/selectors';

import { connect } from 'react-redux';
import React from 'react';

// TODO: Add Save/Load buttons, create list of files, allow downloading.

const Documents = ({ orm }) => {
  const meta = { orm };
  return (
    <section>
      <Header as="h1">Documents</Header>
      <Table collapsing basic="very">
        <Table.Body>
          <Table.Row>
            <Table.HeaderCell>
              <Header as="h3">Entry lists</Header>
            </Table.HeaderCell>
            <Table.Cell>
              <EntryListsDownloads entries={orm.entries} meta={meta} />
            </Table.Cell>
          </Table.Row>
          <Table.Row>
            <Table.HeaderCell>
              <Header as="h3">Athletes' cards</Header>
            </Table.HeaderCell>
            <Table.Cell>
              <AthletesCardsDownloads entries={orm.entries} meta={meta} />
            </Table.Cell>
          </Table.Row>
          <Table.Row>
            <Table.HeaderCell>
              <Header as="h3">Start lists</Header>
            </Table.HeaderCell>
            <Table.Cell>
              <StartListsDownloads sessions={orm.sessions} meta={meta} />
            </Table.Cell>
          </Table.Row>
          <Table.Row>
            <Table.HeaderCell>
              <Header as="h3">Weigh-in lists</Header>
            </Table.HeaderCell>
            <Table.Cell>
              <WeighInListsDownloads sessions={orm.sessions} meta={meta} />
            </Table.Cell>
          </Table.Row>
          <Table.Row>
            <Table.HeaderCell>
              <Header as="h3">Protocols</Header>
            </Table.HeaderCell>
            <Table.Cell>
              <ProtocolsDownloads protocols={orm.protocols} meta={meta} />
            </Table.Cell>
          </Table.Row>
        </Table.Body>
      </Table>
    </section>
  );
};

const mapStateToProps = ({ orm }) => ({
  orm: {
    lifts: liftsSelector(orm),
    events: eventsSelector(orm),
    entries: entriesSelector(orm),
    sessions: sessionsSelector(orm),
    protocols: protocolsSelector(orm),
  },
});

export default connect(mapStateToProps)(Documents);



// WEBPACK FOOTER //
// ./src/pages/Home/Documents.js